/* global angular */
( function () {
	'use strict';

	function visualizeWrapper ( $window, $location ) {
		function visualize () {
			return $window.visualize;
		}

		function getEnv () {
			var host = $location.host();

			return ( host.indexOf( 'dev.' ) > -1 || host.indexOf( 'localhost' ) > -1 )
				&& 'dev' || ( host.indexOf( 'staging.' ) > -1 && 'stage' || 'live' );
		}

		return {
			'visualize' : visualize,
			'getEnv'    : getEnv
		};
	}

	visualizeWrapper.$inject = [ '$window', '$location' ];

	angular
		.module( 'app.components' )
		.factory( 'visualizeJs', visualizeWrapper );
} )();
